// components/MetaTagsPricing.jsx
import { Helmet } from "react-helmet";

function MetaTagsPricing() {
  return (
    <Helmet>
      <title>Pricing | Web Development Services | Beingvin</title>
      <meta name="description" content="Explore affordable and customized pricing plans for web development, UI/UX design, SEO, and more by Beingvin." />
      <link rel="canonical" href="https://beingvin.com/Services/Pricing" />
      <meta name="robots" content="index, follow" />
      <meta property="og:url" content="https://beingvin.com/Services/Pricing" />
      <meta property="og:title" content="Pricing | Beingvin" />
      <meta property="og:description" content="Transparent and flexible pricing plans tailored to your business goals." />
      <meta property="og:image" content="https://beingvin.com/images/favicon_io/android-chrome-512x512.png" />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content="Pricing | Web Development Services | Beingvin" />
      <meta property="twitter:description" content="Affordable pricing for premium web development and digital solutions." />
      <meta property="twitter:image" content="https://beingvin.com/images/favicon_io/android-chrome-512x512.png" />
    </Helmet>
  );
}

export default MetaTagsPricing;
